import { store } from '@/shared/store'

export function isValidEmail (email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email)
}

export function toRupiah(val) {
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
  })
  return formatter.format(val)
}

export function formatTime(timeString) {
    var time = new Date(timeString)
    var d = time.getDate()
    var m = time.getMonth() + 1
    var y = time.getFullYear()
    var h = time.getHours()
    var i = time.getMinutes()
    var s = time.getSeconds()
    // yyyy-mm-dd hh:ii:ss
    return y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d) + ' ' + (h<=9 ? '0' + h : h) + ':' + (i<=9 ? '0' + i : i) + ':' + (s<=9 ? '0' + s : s)
}

export function debounce(fn, delay, isProcessing = false) {
  var timeoutID = null
  return function () {
    if (isProcessing) {
      store.setIsProcessing(true)
    }
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export function handleDownloadFile(response) {
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', response.headers.filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
